import amai from './amai';
// 导出AMAI服务
export { amai };

// 为了向后兼容，继续导出之前的服务名称
export const assetService = amai.asset;
export const chatService = amai.chat;
export const generationService = amai.generation;
export const groupService = amai.group;
export const modelService = amai.model;
export const userService = amai.user;
export const toolsService = amai.tools;
export const skillService = amai.skill;

export const EditorService = amai.editor;

// AMAI认证服务的兼容导出
export const authService = amai.auth;

// 版本服务
export const versionService = amai.version;

// 文档解析服务
export const documentService = amai.document;

// 导出类型
export * from './types';
